import React from "react";

import { gettext } from "web/script/modules/django-i18n";
import { TrackLeadPage } from "web/types/serializers";
import * as styles from "./styles.css";

import LystLogo from "img/branding/lyst-logo-2020-black.svg?inline";
import { useTrackLead } from "web/react/hooks/use-track-lead/use-track-lead";

export function TrackRedirectPage(props: TrackLeadPage): React.ReactElement {
    useTrackLead(props);

    return (
        <div className={styles.container}>
            <div className={styles.redirectInterstitial}>
                <div className={styles.logo}>
                    <LystLogo width={"100%"} height={"100%"} />
                </div>

                <h1 className={styles.heading}>
                    {props.is_returning
                        ? props.redirect_title
                        : gettext("redirect.taking_to.title")}
                </h1>

                {!props.is_returning && (
                    <>
                        {props.retailer_photo && (
                            <img
                                className={styles.retailerLogo}
                                src={props.retailer_photo}
                                alt={`${props.retailer_name} logo`}
                            />
                        )}

                        <h2 className={styles.retailerName}>{props.retailer_name}</h2>
                    </>
                )}

                <div className={styles.loader}>
                    <div className={styles.loaderElement}></div>
                    <div className={styles.loaderElement}></div>
                    <div className={styles.loaderElement}></div>
                    <div className={styles.loaderElement}></div>
                </div>

                <p className={styles.link}>
                    {gettext("redirect.taking_to.description")}{" "}
                    <a href={props.is_returning ? props.origin_url : props.meta_redirect_url}>
                        <b>{gettext("redirect.taking_to.link")}</b>
                    </a>
                </p>
            </div>
        </div>
    );
}
